import React from 'react';

import Accordion from 'components/Accordion';
import useModel from 'hooks/Meteorology/Weather/SeasonalForecast/useModel';
import TitleSemiBold from 'components/Typography/TitleSemiBold';
import RadioButton from 'components/DesignSystem/RadioButton';

export default function Models() {
  const { models, model, setModel } = useModel();

  return (
    <Accordion.Item eventKey="models">
      <Accordion.Header>
        <TitleSemiBold>Modelo</TitleSemiBold>
      </Accordion.Header>
      {models.length === 0 && (
        <Accordion.Body>
          Selecione uma variável.
        </Accordion.Body>
      )}
      {models.length !== 0 && (
        <Accordion.Body className="d-grid control-panel-columns column-gap-3">
          {models.map((m) => (
            <RadioButton
              key={m.id}
              id={`model-checkbox-${m.id}`}
              className="text-uppercase"
              label={m.label}
              onChange={() => { setModel(m.id); }}
              checked={m.id === model}
            />
          ))}
        </Accordion.Body>
      )}
    </Accordion.Item>
  );
}
